import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './@auth/auth-material/auth.guard';
import { LoginGuard } from './@auth/auth-material/login.guard';
import { OnboardingAccessGuard } from './onboarding-process/guards/onboarding-access.guard';
import { OnboardingCompleteGuard } from './onboarding-process/guards/onboarding-complete.guard';
import { PolicyConsentGuard } from './policy-consent/guards/policy-consent.guard';

const routes: Routes = [
  {
    path: 'auth',
    canActivate: [LoginGuard],
    loadChildren: () =>
      import('../app/@auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard, OnboardingAccessGuard],
    loadChildren: () =>
      import('./onboarding-process/onboarding-process.module').then(
        (m) => m.OnboardingProcessModule
      ),
  },
  {
    path: 'policy-consent',
    canActivate: [AuthGuard, OnboardingCompleteGuard],
    loadChildren: () =>
      import('./policy-consent/policy-consent.module').then(
        (m) => m.PolicyConsentModule
      ),
  },
  {
    path: 'master',
    canActivate: [AuthGuard, OnboardingCompleteGuard, PolicyConsentGuard],
    loadChildren: () =>
      import('../app/@modules/master.module').then((m) => m.MasterModule),
  },
  {
    path: 'e',
    loadChildren: () =>
      import('../app/open-pages/open-pages.module').then(
        (m) => m.OpenPagesModule
      ),
  },
  // {
  //   path: 'request-form',
  //   loadChildren: () =>
  //     import('../app/request/request.module').then((m) => m.RequestModule),
  // },

  // {
  //   path: 'send-rfp-link',
  //   loadChildren: () =>
  //     import('../app/send-rfp/send-rfp.module').then((m) => m.SendRfpModule),
  // },
  {
    path: 'customer-type',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './@modules/itticketing/configurationalmaster/customer-type/customer-type.module'
      ).then((m) => m.CustomerTypeModule),
  },
  {
    path: 'training-name',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './@modules/itticketing/configurationalmaster/training-name/training-name.module'
      ).then((m) => m.TrainingNameModule),
  },
  {
    path: 'level-slab',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './@modules/itticketing/configurationalmaster/level-slab/level-slab.module'
      ).then((m) => m.LevelSlabModule),
  },
  {
    path: 'pricing-level',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './@modules/itticketing/configurationalmaster/pricing-level/pricing-level.module'
      ).then((m) => m.PricingLevelModule),
  },

  // {
  //   path: 'receive-response',
  //   loadChildren: () =>
  //     import('./answering-form/answering-form.module').then(
  //       (m) => m.AnsweringFormModule
  //     ),
  // },

  // {
  //   path: 'response-confirmation',
  //   loadChildren: () =>
  //     import('./branching-form/branching-form.module').then(
  //       (m) => m.BranchingFormModule
  //     ),
  // },

  // {
  //   path: 'send-vendor',
  //   loadChildren: () =>
  //     import('./send-link-vendor/send-link-vendor.module').then(
  //       (m) => m.SendLinkVendorModule
  //     ),
  // },

  {
    path: 'create-employee-module',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('../app/employee-master/employee-master.module').then(
        (m) => m.EmployeeMasterModule
      ),
  },

  {
    path: 'new-employee-form',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./new-employee-form/new-employee-form.module').then(
        (m) => m.NewEmployeeFormModule
      ),
  },
  {
    path: 'open-house-training',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../app/registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  {
    path: 'send-negotiation-link',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../app/send-negotiate-link/send-negotiate-link.module').then(
        (m) => m.SendNegotiateLinkModule
      ),
  },
  {
    path: 'form-candidate/:id',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('../app/candidate-form/candidate-form.module').then(
        (m) => m.CandidateFormModule
      ),
  },
  {
    path: 'form-candidate-africa/:id',
    loadChildren: () =>
      import('../app/africa-candidate-form/africa-candidate-form.module').then(
        (m) => m.AfricaCandidateFormModule
      ),
  },
  {
    path: 'company-remarks',
    loadChildren: () =>
      import('../app/company-remarks/company-remarks.module').then(
        (m) => m.CompanyRemarksModule
      ),
  },
  {
    path: 'candidate-offer-letter',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './candidate-offer-letter-receive/candidate-offer-letter-receive.module'
      ).then((m) => m.CandidateOfferLetterModule),
  },
  {
    path: 'manager-intern-review',
    loadChildren: () =>
      import(
        './manager-intern-review/manager-intern-review.module'
      ).then((m) => m.ManagerInternReviewModule),
  },
  {
    path: 'crm-preview',
    // canActivate: [AuthGuard],
    loadChildren: () => import('./preview/crm.module').then((m) => m.CrmModule),
  },
  {
    path: 'candidate-upload-document',
    loadChildren: () =>
      import(
        './@modules/recuitment-module/bgv/candidate-upload-doc/candidate-upload-doc-public.module'
      ).then((m) => m.CandidateUploadDocPublicModule),
  },
  {
    path: 'africa-candidate-upload-document',
    loadChildren: () =>
      import(
        './@modules/africa-recruitment/document-collection/candidate-upload/africa-candidate-upload-doc-public.module'
      ).then((m) => m.AfricaCandidateUploadDocPublicModule),
  },
  {
    path: 'africa-candidate-sign-contract',
    loadChildren: () =>
      import(
        './@modules/africa-recruitment/employment-contract/candidate-sign/africa-candidate-sign-contract-public.module'
      ).then((m) => m.AfricaCandidateSignContractPublicModule),
  },
  {
    path: 'sms-campaigns',
    loadChildren: () =>
      import('./@modules/campaigns/sms-campaigns/sms-campaigns.module').then(
        (m) => m.SmsCampaignsModule
      ),
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
